/**
 * Derives the true product count from an Athos results payload by subtracting
 * any injected merchandising banners from the API's total. Shared by the search
 * components and the collection grid (which broadcasts it to the
 * `<x-product-count>` custom element).
 */
export function calculateProductCount(results) {
  const apiTotalResults = results?.pagination?.totalResults || 0
  const totalBanners = (results?.merchandising?.content?.inline?.length || 0) + (results?.merchandising?.content?.header?.length || 0) + (results?.merchandising?.content?.footer?.length || 0) + (results?.merchandising?.content?.banner?.length || 0)
  return Math.max(0, apiTotalResults - totalBanners)
}
